<template>
  <div class="ret-cards-wrapper">
    <v-card class="ret-header-card">
      <v-card-title>
        <v-layout row>
          <v-flex xs6 md3>
            <v-text-field
              clearable
              hide-details
              solo
              v-model="search"
              :label="$t('search')"
              append-icon="search"
              data-test="checklists-search"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md3>
            <v-switch
              v-model="showArchived"
              input-value="true"
              :label="$t('archived')"
              class="mt-2"
              data-test="checklists-archived"
            ></v-switch>
          </v-flex>
          <v-flex grow class="text-right">
            <v-btn
              color="accent"
              fab
              small
              dark
              @click="$router.push({name: `${model.name}/new`})"
              data-test="new-checklist"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>

    <v-card class="ret-card-new">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="pagedItems"
          :server-items-length="totalItems"
          :footer-props="{ 'items-per-page-text': $t('rows-per-page'), 'items-per-page-options': [10,20,50,100,{ text: $t('all'), value: -1 }] }"
          :no-data-text="$t('no-data-available')"
          :options.sync="options"
          :loading="loading"
        >
          <template slot="item" slot-scope="props">
            <tr @click="showItemDetail(props.item)" data-test="checklist">
              <td>
                <v-icon
                  v-if="props.item.summary"
                  :title="$t('checklists.summary')"
                >check_circle_outline</v-icon>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.version }}</td>
              <td v-if="props.item.archivedAt">
                <v-btn text icon small :title="$t('restore')" @click.stop="restoreItem(props.item)">
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import lazyItems from '../helpers/lazy-items.es6'

export default {
  mixins: [lazyItems],
  data () {
    return {
      model: {
        name: 'checklists',
        searchColumns: ['code', 'name']
      },
      defaultHeaders: [
        { text: '', value: 'summary', sortable: false },
        { text: this.$t('code'), value: 'code' },
        { text: this.$t('name'), value: 'name' },
        { text: this.$t('checklists.version'), value: 'version' }
      ]
    }
  }
}
</script>
